import SkeletonLoader from './index';

const TableSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {/* Table Header */}
      <div className="flex items-center justify-between p-4 bg-neutral-200 rounded-md ">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <SkeletonLoader
            key={i}
            width={100}
            height={20}
            className="bg-neutral-200 "
          />
        ))}
      </div>

      {/* Table Rows */}
      {[...Array(5)].map((_, row) => (
        <div
          key={row}
          className="flex items-center justify-between p-4 border-b border-neutral-200 bg-white"
        >
          <div className="flex items-center gap-3">
            <SkeletonLoader variant="circle" width={40} height={40} />
            <SkeletonLoader width={120} height={20} />
          </div>
          <SkeletonLoader width={150} height={20} />
          <SkeletonLoader width={80} height={24} className="rounded-full" />
          <SkeletonLoader width={80} height={24} className="rounded-full" />
          <SkeletonLoader width={100} height={20} />
          <SkeletonLoader width={40} height={20} />
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
